import { Button, Divider, Modal, TextField } from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import React, { useState } from "react";
import { toast } from "react-toastify";
import apple from "../assets/apple.png";
import facebook from "../assets/facebook.png";
import google from "../assets/google.png";
import appstore from "../store/appstore";
function LoginSignup({ isLoginModalOpen, setIsLoginModalOpen, isMobileview }) {
  const { setUserlogin, setUserData } = appstore();
  const [userDetails, setUserDetails] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    username: "",
  });
  const [view, setView] = useState("login");
  const handleLogin = async () => {
    if (!userDetails.email || !userDetails.password) {
      toast.error("Please fill all the details !");
      return;
    }
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://simulyst.com/backend/users/login",
      headers: {
        "Content-Type": "application/json",
      },
      data: { email: userDetails?.email, password: userDetails?.password },
    };
    try {
      const response = await axios.request(config);
      localStorage.setItem("userDetails", JSON.stringify(response.data));
      setUserlogin(true);
      setUserData(response.data);
      toast.success("Login successful !");
      setIsLoginModalOpen(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
    }
  };
  const handleSignup = async () => {
    if (
      !userDetails.email ||
      !userDetails.password ||
      !userDetails.confirmPassword ||
      !userDetails.username
    ) {
      toast.error("Please fill all the details !");
      return;
    }
    if (userDetails.confirmPassword != userDetails.password) {
      toast.error("Password is not matching !");
      return;
    }
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://simulyst.com/backend/users",
      headers: {
        "Content-Type": "application/json",
      },
      data: userDetails,
    };
    try {
      const response = await axios.request(config);
      toast.success("Signup successful !");
      setView("login");
      // setAllpodcasts(response?.data);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
    }
  };
  return (
    <Modal
      open={isLoginModalOpen}
      onClose={() => {
        setIsLoginModalOpen(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: isMobileview ? "80%" : "32%",
          bgcolor: "background.paper",
          p: isMobileview ? 2 : 4,
          display: "flex",
          flexDirection: "column",
          gap: "6px",
          padding: "25px",
          borderRadius: isMobileview ? "10px" : "20px",
        }}
      >
        {view == "login" ? (
          <>
            <Box fontSize={"30px"} fontWeight={"600"}>
              Login
            </Box>
            <TextField
              id="outlined-basic"
              label="Email"
              variant="outlined"
              style={{ marginTop: "25px" }}
              value={userDetails.email}
              onChange={(e) => {
                setUserDetails({
                  ...userDetails,
                  email: e?.target?.value,
                });
              }}
            />
            <TextField
              id="outlined-basic"
              label="Password"
              variant="outlined"
              type="password"
              style={{ marginTop: "15px" }}
              value={userDetails.password}
              onChange={(e) => {
                setUserDetails({
                  ...userDetails,
                  password: e?.target?.value,
                });
              }}
            />
            <Box
              fontSize={isMobileview ? "12px" : "14px"}
              display={"flex"}
              justifyContent={"flex-end"}
              marginBottom={"10px"}
              marginTop={"10px"}
            >
              {" "}
              Forget Password ?
            </Box>
            <Button variant="contained" onClick={handleLogin}>
              Login
            </Button>
            <Box
              fontSize={isMobileview ? "12px" : "14px"}
              display={"flex"}
              justifyContent={"flex-end"}
              marginBottom={"10px"}
              marginTop={"10px"}
            >
              {" "}
              Don’t have an account?{" "}
              <span
                style={{
                  color: "#C789E4",
                  marginLeft: "5px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setView("signup");
                }}
              >
                Sign Up
              </span>
            </Box>
            {/* <Divider>Or</Divider>
            <Box display={"flex"} justifyContent={"space-around"}>
              <Button
                variant="outlined"
                style={{
                  color: "black",
                  border: "0.5px solid #8C837D",
                  borderRadius: "8px",
                  width: isMobileview ? "90px" : "120px",
                  height: isMobileview ? "36px" : "55px",
                  fontSize: isMobileview ? "12px" : "14px",
                  textTransform: "none",
                }}
                size="small"
              >
                <img
                  src={google}
                  style={{
                    height: "20px",
                    width: "20px",
                    marginRight: isMobileview ? "4px" : "5px",
                  }}
                />
                Google
              </Button>
              <Button
                variant="outlined"
                style={{
                  color: "black",
                  border: "0.5px solid #8C837D",
                  borderRadius: "8px",
                  width: isMobileview ? "90px" : "120px",
                  height: isMobileview ? "36px" : "55px",
                  fontSize: isMobileview ? "12px" : "14px",
                  textTransform: "none",
                }}
              >
                <img
                  src={facebook}
                  style={{
                    height: "20px",
                    width: "20px",
                    marginRight: isMobileview ? "4px" : "5px",
                  }}
                />{" "}
                Facebook
              </Button>
              <Button
                variant="outlined"
                style={{
                  color: "black",
                  border: "0.5px solid #8C837D",
                  borderRadius: "8px",
                  width: isMobileview ? "90px" : "120px",
                  height: isMobileview ? "36px" : "55px",
                  fontSize: isMobileview ? "12px" : "14px",
                  textTransform: "none",
                }}
              >
                <img
                  src={apple}
                  style={{
                    height: "20px",
                    width: "20px",
                    marginRight: isMobileview ? "0px" : "5px",
                    marginLeft: isMobileview ? "-10px" : "0px",
                  }}
                />
                Apple ID
              </Button>
            </Box>{" "} */}
          </>
        ) : (
          <>
            <Box fontSize={"30px"} fontWeight={"600"}>
              Signup
            </Box>
            <TextField
              id="outlined-basic"
              label="User Name"
              variant="outlined"
              style={{ marginTop: "25px" }}
              value={userDetails?.username}
              onChange={(e) => {
                setUserDetails({
                  ...userDetails,
                  username: e?.target?.value,
                });
              }}
            />
            <TextField
              id="outlined-basic"
              label="Email"
              variant="outlined"
              style={{ marginTop: "25px" }}
              value={userDetails?.email}
              onChange={(e) => {
                setUserDetails({
                  ...userDetails,
                  email: e?.target?.value,
                });
              }}
            />
            <TextField
              id="outlined-basic"
              label="Password"
              variant="outlined"
              type="password"
              style={{ marginTop: "15px" }}
              value={userDetails?.password}
              onChange={(e) => {
                setUserDetails({
                  ...userDetails,
                  password: e?.target?.value,
                });
              }}
            />
            <TextField
              id="outlined-basic"
              label="Confirm Password"
              type="password"
              variant="outlined"
              style={{ marginTop: "15px" }}
              value={userDetails?.confirmPassword}
              onChange={(e) => {
                setUserDetails({
                  ...userDetails,
                  confirmPassword: e?.target?.value,
                });
              }}
            />
            <Box
              fontSize={isMobileview ? "12px" : "14px"}
              display={"flex"}
              justifyContent={"flex-end"}
              marginBottom={"10px"}
              marginTop={"10px"}
            >
              {" "}
              Have an account?
              <span
                style={{
                  color: "#C789E4",
                  marginLeft: "5px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setView("login");
                }}
              >
                Login
              </span>
            </Box>
            <Button variant="contained" onClick={handleSignup}>
              Signup
            </Button>
            {/* <Divider>Or</Divider>
            <Box display={"flex"} justifyContent={"space-around"}>
              <Button
                variant="outlined"
                style={{
                  color: "black",
                  border: "0.5px solid #8C837D",
                  borderRadius: "8px",
                  width: isMobileview ? "90px" : "120px",
                  height: isMobileview ? "36px" : "55px",
                  fontSize: isMobileview ? "12px" : "14px",
                  textTransform: "none",
                }}
                size="small"
              >
                <img
                  src={google}
                  style={{
                    height: "20px",
                    width: "20px",
                    marginRight: isMobileview ? "4px" : "5px",
                  }}
                />
                Google
              </Button>
              <Button
                variant="outlined"
                style={{
                  color: "black",
                  border: "0.5px solid #8C837D",
                  borderRadius: "8px",
                  width: isMobileview ? "90px" : "120px",
                  height: isMobileview ? "36px" : "55px",
                  fontSize: isMobileview ? "12px" : "14px",
                  textTransform: "none",
                }}
              >
                <img
                  src={facebook}
                  style={{
                    height: "20px",
                    width: "20px",
                    marginRight: isMobileview ? "4px" : "5px",
                  }}
                />{" "}
                Facebook
              </Button>
              <Button
                variant="outlined"
                style={{
                  color: "black",
                  border: "0.5px solid #8C837D",
                  borderRadius: "8px",
                  width: isMobileview ? "90px" : "120px",
                  height: isMobileview ? "36px" : "55px",
                  fontSize: isMobileview ? "12px" : "14px",
                  textTransform: "none",
                }}
              >
                <img
                  src={apple}
                  style={{
                    height: "20px",
                    width: "20px",
                    marginRight: isMobileview ? "0px" : "5px",
                    marginLeft: isMobileview ? "-10px" : "0px",
                  }}
                />
                Apple ID
              </Button>
            </Box>{" "} */}
          </>
        )}
      </Box>
    </Modal>
  );
}

export default LoginSignup;
